import { render, staticRenderFns } from "./InboundList.vue?vue&type=template&id=f50ef3ac&scoped=true&"
import script from "./InboundList.vue?vue&type=script&lang=js&"
export * from "./InboundList.vue?vue&type=script&lang=js&"
import style0 from "./InboundList.vue?vue&type=style&index=0&id=f50ef3ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50ef3ac",
  null
  
)

export default component.exports